import { AppStoreState } from '../../appStore';

export const envSelector = (state: AppStoreState) => state.env.environment;

export const setEnvSelector = (state: AppStoreState) =>
  state.env.setEnvironment;
